import { NgIf, NgTemplateOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import { ThemeSettingsService } from '@services/theme-settings.service';
import { AppSettings } from '../../Constants/sharedConstants';

const DEFAULT_LOGO = 'assets/images/smarttank-logo.png';

/**
 * The signed-out page shell: a drifting cloud panel on the left, and on the right the help link
 * and, above the page's own content, the theme's logo (SmartTank's when unthemed) followed by
 * "/ AMETEK". For every page a visitor reaches before or without signing in - the login page, the
 * access-link landing page and the purpose pages it hosts (set password, confirm sign-in).
 *
 * A page may put its own copy on the cloud panel by projecting an element marked
 * `publicPageAside`; without one the panel is just cloud. The panel is hidden below `md`.
 */
@Component({
  selector: 'app-public-page-layout',
  standalone: true,
  imports: [NgIf, NgTemplateOutlet, MatIconModule, TranslateModule],
  templateUrl: './public-page-layout.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PublicPageLayoutComponent {
  readonly logoUrl: string;
  /** Where the theme's own logo links to, as it does in the signed-in title bar. */
  readonly logoHyperlink = AppSettings.UIAppConfig?.currentTheme?.customerLogoHyperlink;

  constructor(themeSettings: ThemeSettingsService) {
    const theme = themeSettings.currentTheme$.value;
    this.logoUrl = theme?.themeId ? theme.LogoUrlPath : DEFAULT_LOGO;
  }
}
